import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../config';
import { fixUrlProtocol } from '../../utils/misc';

const DEFAULT_PAGE_URL = `${API_BASE_URL}/notifications/all`;

const useUserNotifications = (token) => {
    const [notifications, setNotifications] = useState([]);
    const [nextPageUrl, setNextPageUrl] = useState(DEFAULT_PAGE_URL);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchUserNotifications = async (url) => {
        if (!url || loading) return;

        setLoading(true);

        const safeUrl = fixUrlProtocol(url);

        try {
            const response = await fetch(safeUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setNotifications((prev) => [...prev, ...data.notifications.data]);
            setNextPageUrl(data.notifications.next_page_url);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (notifications.length === 0 && token) {
            console.info('Fetching user notifications');
            fetchUserNotifications(nextPageUrl);
        }

    }, [token]);

    /**
     * Load more notifications when the user scrolls to the bottom of the list
     */
    const loadMore = () => {
        fetchUserNotifications(nextPageUrl);
    };

    /**
     * Force refresh the list of notifications
     */
    const forceRefresh = () => {
        setNotifications([]);
        setNextPageUrl(DEFAULT_PAGE_URL);
        return fetchUserNotifications(DEFAULT_PAGE_URL);
    };

    return { notifications, loading, error, loadMore, hasMore: !!nextPageUrl, forceRefresh };
};

export default useUserNotifications;